import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/personal',
  component: layout,
  children: ((pre) => [
    {
      path: 'dashBoard',
      name: `${pre}dashBoard`,
      meta: {
        ...meta,
        cache: false,
        title: 'Dashboard',
        head: true,
        funcID: 'T000101',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/dashBoard'),
    },
    {
      path: 'myShoppingCart',
      name: `${pre}myShoppingCart`,
      meta: {
        ...meta,
        cache: true,
        title: '我的购物车',
        head: true,
        funcID: 'T000102',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myShoppingCart'),
    },
    {
      path: 'myFavorites',
      name: `${pre}myFavorites`,
      meta: {
        ...meta,
        cache: true,
        title: '我的收藏',
        head: true,
        funcID: 'T000103',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myFavorites'),
    },
    {
      path: 'myRecommend',
      name: `${pre}my-recommend`,
      meta: {
        ...meta,
        cache: true,
        title: '我的客户推荐',
        head: true,
        funcID: 'T000104',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myRecommend'),
    },
    {
      path: 'myQuotation',
      name: `${pre}myQuotation`,
      meta: {
        ...meta,
        cache: true,
        title: '我的报价记录',
        head: true,
        funcID: 'T000105',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myQuotation'),
    },
    {
      path: 'myQuotation/:pageType/:quotationCode',
      name: `${pre}myQuotation-edit`,
      meta: {
        ...meta,
        cache: true,
        title: '我的报价记录编辑',
        funcID: 'T000105',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myQuotation/components/edit'),
    },
    {
      path: 'myProofing',
      name: `${pre}my-proofing`,
      meta: {
        ...meta,
        cache: true,
        title: '我的打样记录',
        head: true,
        funcID: 'T000106',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myProofing'),
    },
    {
      path: 'myScmInfo',
      name: `${pre}myScmInfo`,
      meta: {
        ...meta,
        cache: true,
        title: '我的供应商',
        head: true,
        funcID: 'T000107',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myScmInfo'),
    },
    {
      path: 'myScmInfo/visitEdit/:pageType/:visitCode?/:scmCode?',
      name: `${pre}myScmInfo-myVisit-edit`,
      meta: {
        ...meta,
        cache: true,
        title: '编辑供应商拜访记录',
        funcID: 'T000107',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myScmInfo/components/myVisit/edit'),
    },
    {
      path: 'myScmInfo/visitView/:pageType/:visitCode',
      name: `${pre}myScmInfo-myVisit-view`,
      meta: {
        ...meta,
        cache: true,
        title: '查看供应商拜访记录',
        funcID: 'T000107',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myScmInfo/components/myVisit/view'),
    },
    {
      path: 'myScmInfo/rating/:pageType/:visitScoreCode',
      name: `${pre}myScmInfo-myVisit-rating-edit`,
      meta: {
        ...meta,
        cache: true,
        title: '供应商评分',
        funcID: 'T000107',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myScmInfo/components/rating/edit'),
    },
    {
      path: 'my-recommend/d/:type/:recommendCode',
      name: `${pre}my-recommend-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '我的客户推荐详情',
        funcID: 'T000104',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myRecommend/components/detail'),
    },
    {
      path: 'myTravelReimbursement',
      name: `${pre}myTravelReimbursement`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'T000109',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myTravelReimbursement'),
    },
    {
      path: 'myTravelReimbursement/:pageType/:code?',
      name: `${pre}myTravelReimbursement-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { tripReimbursementNo = '' } = $route.query || {}
          if (tripReimbursementNo) {
            return `出差费用报销 | ${tripReimbursementNo}`
          }
          return '出差费用报销'
        },
        funcID: 'T000109',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myTravelReimbursement/detail'),
    },
    {
      path: 'myTravel',
      name: `${pre}myTravel`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000108',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myTravel'),
    },
    {
      path: 'myTravel/:pageType/:code?',
      name: `${pre}myTravelDetail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { userTripRequestNo = '' } = $route.query || {}
          if (userTripRequestNo) {
            return `出差申请详情 | ${userTripRequestNo}`
          }
          return '出差申请详情'
        },
        funcID: 'T000108',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myTravel/detail'),
    },
    {
      path: 'myPaymentRequest',
      name: `${pre}myPaymentRequest`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '日常请款单',
        funcID: 'T000110',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myPaymentRequest'),
    },
    {
      path: 'myPaymentRequest/:pageType/:code?',
      name: `${pre}myPaymentRequest-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { userPaymentRequestNo = '' } = $route.query || {}
          if (userPaymentRequestNo) {
            return `日常请款 | ${userPaymentRequestNo}`
          }
          return '日常请款'
        },
        funcID: 'T000110',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myPaymentRequest/detail'),
    },
    {
      path: 'myReimbursement',
      name: `${pre}myReimbursement`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '日常报销单',
        funcID: 'T000111',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myReimbursement'),
    },
    {
      path: 'myReimbursement/:pageType/:code?',
      name: `${pre}myReimbursement-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { userReimbursementNo = '' } = $route.query || {}
          if (userReimbursementNo) {
            return `日常报销 | ${userReimbursementNo}`
          }
          return '日常报销单'
        },
        funcID: 'T000111',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myReimbursement/detail'),
    },
    {
      path: 'myLoanRequest',
      name: `${pre}myLoanRequest`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '借款申请单',
        funcID: 'T000112',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myLoanRequest'),
    },
    {
      path: 'myLoanRequest/:pageType/:code?',
      name: `${pre}myLoanRequest-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { userLoanRequestNo = '' } = $route.query || {}
          if (userLoanRequestNo) {
            return `借款申请 | ${userLoanRequestNo}`
          }
          return '借款申请'
        },
        funcID: 'T000112',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myLoanRequest/detail'),
    },
    {
      path: 'userBizContactForm',
      name: `${pre}myBizContactForm`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '合祥财务业务联络单',
        funcID: 'T000113',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myBizContactForm'),
    },
    {
      path: 'userBizContactForm/:pageType/:code?',
      name: `${pre}myBizContactForm-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { userBizContactFormNo = '' } = $route.query || {}
          if (userBizContactFormNo) {
            return `合祥财务业务联络 | ${userBizContactFormNo}`
          }
          return '合祥财务业务联络'
        },
        funcID: 'T000113',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/myBizContactForm/detail'),
    },
    {
      path: 'myResearchFabric',
      name: `${pre}myResearchFabric`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        funcID: 'T000114',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/myResearchFabric'),
    },
    {
      path: 'userMaterialAbnormal',
      name: `${pre}userMaterialAbnormal`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '合祥物料异常联络单',
        funcID: 'T000115',
        PID: 'T00',
      },
      component: () => import('@/views/digital/personal/userMaterialAbnormal'),
    },
    {
      path: 'userMaterialAbnormal/:pageType/:code?',
      name: `${pre}userMaterialAbnormal-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { materialAbnormalNo = '' } = $route.query || {}
          if (materialAbnormalNo) {
            return `合祥物料异常联络单 | ${materialAbnormalNo}`
          }
          return '合祥物料异常联络单'
        },
        funcID: 'T000115',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/personal/userMaterialAbnormal/detail'),
    },
    {
      path: 'taskCenter',
      name: `${pre}taskCenter`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        title: '任务中心',
        funcID: 'T000116',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'pt-0 mb-0' },
        },
      },
      component: () => import('@/views/digital/personal/taskCenter'),
    },
    {
      path: 'taskCenter/:pageType/:code?',
      name: `${pre}taskCenter-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { tskInfoNo = '' } = $route.query || {}
          if (tskInfoNo) {
            return `任务中心 | ${tskInfoNo}`
          }
          return '任务中心'
        },
        funcID: 'T000116',
        PID: 'T00',
        // pageConfig: { layout: { class: 'bg-transparent-meetingSet' } },
      },
      component: () => import('@/views/digital/personal/taskCenter/detail'),
    },
  ])('personal-'),
}
